/**
 * 输入一个 数组/Set/Map/WeakSet/WeakMap/对象…… 检查一个元素是否存在在里面
 */
export function contains(collection, item) {
  if (!collection) return false;
  if (Array.isArray(collection)) return collection.includes(item);
  if ('has' in collection && typeof collection.has === 'function') return collection.has(item);
  return Object.hasOwnProperty.call(collection, String(item));
}